import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FileUploader } from 'ng2-file-upload';
import { ElementService } from '../../services/element.service';
import { StatService } from '../../services/stat.service';
import { GlobalConstantsService } from '../../services/global-constants.service';
import { ToasterService } from 'angular2-toaster';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import {Element} from '../../services/element';
import {toFormObject} from '../../services/utils';
import {mapField} from '../../services/field';

@Component({
  selector: 'app-element',
  templateUrl: './element.component.html',
  styleUrls: ['./element.component.css']
})
export class ElementComponent implements OnInit {
  public thumbUploader:FileUploader = new FileUploader({url: ''});
  public videoUploader:FileUploader = new FileUploader({url: ''});
  sub;
  kitId;
  elementId;
  element: any = {};
  stats;
  constants = [];
  metaFields = [];

  kitMetaDataFields = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private elementService: ElementService,
    private statService: StatService,
    private toasterService: ToasterService,
    private activeRoute: ActivatedRoute,
    private globalConstantsService: GlobalConstantsService,
    private dragulaService: DragulaService
  ) {
    let {kit, kitMetaDataFields} = this.activeRoute.snapshot.data['elementFields'];
    this.kitMetaDataFields = kitMetaDataFields;
  }

  ngOnInit() {
    this.globalConstantsService.getAll().subscribe(constants => {
      this.constants = constants;
    });
    this.stats = this.statService.stats;
    this.sub = this.route
      .queryParams
      .subscribe(params => {
        this.kitId = params['kit'];
        this.elementId = params['element'];

        if (this.elementId) {

          this.elementService.getById(this.elementId).subscribe((element: Element) => {

            ensureCompNameField(element.fields, +params['element']);

            this.element = toFormObject(element);
            this.metaFields = this.element.metaFields;
          });
        } else {
          this.init();
        }
      });

    this.thumbUploader.onAfterAddingFile = (fileItem) => {
      this.element.thumbnail = fileItem._file;
    };
    this.videoUploader.onAfterAddingFile = (fileItem) => {
      this.element.video_preview = fileItem._file;
    };

    this.dragulaService.setOptions('field-bag', {
      removeOnSpill: false
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.dragulaService.destroy('field-bag');
  }

  itemizedMetaData() {
    return this.element.fields.filter((field: any) => field.scope == 'element' && field.hidden == 1);
  }

  init() {
    this.element = {
      name: '',
      subtitle: '',
      description: '',
      fields: [{
        element_id: this.element.id ? this.element.id : null,
        engine_id: "comp_name",
        hidden: 1,
        kit_id: null,
        label: "Comp Name",
        limit: 0,
        max_length: null,
        options: null,
        ord: 0,
        placeholder: "text here",
        required: 1,
        scope: "element",
        sub_label: "sublabel here",
        type: "text",
        value: ""
      }],
      type_id: 1,
      genre_id: 1,
      project_id: 1,
      'element_kits[]': this.kitId
    };
  }

  save(element) {
    element.kitId = this.kitId;
    this.elementService.save(element).subscribe(newElement => {
      this.element = newElement;
      this.elementId = this.element.id;
      this.toasterService.pop('success', 'Success', 'Element saved');
    }, error => {
      this.toasterService.pop('error', 'Error', error);
    });
  }

  delete(element) {
    this.elementService.delete(element.id).subscribe(() => {
      this.router.navigate(['/dashboard/library']);
      this.toasterService.pop('success', 'Success', 'Element deleted');
    }, error => {
      this.toasterService.pop('error', 'Error', error);
    });
  }

  deleteField(field, fields, index) {
    this.globalConstantsService.delete(field.id).subscribe(() => {
      this.toasterService.pop('success', 'Success', 'Field deleted');
      fields.splice(index, 1);
    });
  }

}


export function ensureCompNameField(fields: any, elementId: number) {
  let hasCompName = false;

  fields.forEach((field: any) => {
    if (field.engine_id == 'comp_name') {
      hasCompName = true;
    }
  });

  if (!hasCompName) {
    fields.push(mapField({
      id: null,
      element_id: elementId,
      engine_id: "comp_name",
      hidden: 1,
      kit_id: null,
      label: "Comp Name",
      limit: 0,
      max_length: null,
      options: null,
      ord: 0,
      placeholder: "text here",
      required: 1,
      scope: "element",
      sub_label: "sublabel here",
      type: "text",
      value: ""
    }))
  }


  return fields;
}


// WEBPACK FOOTER //
// ./src/app/components/element/element.component.ts